import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { M8ProdStackDTO } from 'services/production/types';
import { getM8UserURL } from 'services/production/utils/getM8URL';

export const getProdStackInfo = async (): Promise<null | M8ProdStackDTO> => {
  const response = await customFetch(getM8UserURL('getProdStackInfo'));

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  try {
    const data = await response.json();

    return data;
  } catch {
    return null;
  }
};
